import i18next, { TOptions } from "i18next";

export type TranslateFnType = (
  id: string,
  value?: TOptions<{ [key: string]: string | number }> | string
) => string;

//REFACTOR: Ver uma forma de não precisar passar um obj, somente o valor
export const translate: TranslateFnType = (id, value) => i18next.t(id, value as string);
